import { Component, Output, EventEmitter, HostListener } from '@angular/core';
import { FileUploadStatus, DrFileMeta, DrFileUploadMeta } from '@app/shared/models/dr-file';
import { TranslateService } from '@ngx-translate/core';
import { Thumbnailable, ThumbNailBaseComponent } from '@app/shared/components/file-upload/thumb-nail-base.component';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { BaseModel } from '@app/shared/models/base';
import { FileTypes } from '@app/shared/models/file-type';

@Component({
  selector: 'thumb-nail',
  templateUrl: './thumb-nail.component.html',
  styleUrls: ['./thumb-nail.component.scss']
})
export class ThumbNailComponent<T extends BaseModel & Thumbnailable> extends ThumbNailBaseComponent<T> {

  @Output()
  public view = new EventEmitter<T>();

  @Output()
  public download = new EventEmitter<T>();

  @Output()
  public delete = new EventEmitter<T>();

  @Output()
  public edit = new EventEmitter<DrFileUploadMeta>();

  private openMenu: boolean;

  get menuAvailable(): boolean {
    return this.openMenu && this.statusReadOrError();
  }

  get FileTypes() {
    return FileTypes;
  }

  constructor(protected fileUtilityService: FileUtilityService,
              protected translateService: TranslateService) {
    super(fileUtilityService, translateService);
  }

  public showFile(): void {
    if (this.file.thumbnailStatus === FileUploadStatus.READY && this.canView) {
      this.view.emit(this.file);
    }
  }

  public downloadFile(): void {
    if (this.file.thumbnailStatus === FileUploadStatus.READY && this.canDownload) {
      this.download.emit(this.file);
    }
  }

  public deleteFile(): void {
    if (this.statusReadOrError() && this.canDelete) {
      this.delete.emit(this.file);
    }
  }

  public statusReadOrError(): boolean {
    const readAndError = [FileUploadStatus.READY, FileUploadStatus.ERROR];
    return readAndError.indexOf(this.file.thumbnailStatus) > -1;
  }

  public editFile(file: DrFileMeta): void {
    const photoEditor = this.fileUtilityService.showPhotoEditor(file)
                                               .subscribe(dataUrl => {
        if (dataUrl) {
          this.fileUtilityService.dataURLAsBinaryString(dataUrl, file.filename)
                                 .subscribe(binaryString => {
              const uploadFileMeta: DrFileUploadMeta = file as DrFileUploadMeta;
              uploadFileMeta.fileAsBinaryString = binaryString;
              this.edit.emit(uploadFileMeta);
            });
        }
      });

    this.subscriptions.push(photoEditor);
  }

  @HostListener('mouseover')
  public onHover() {
    this.openMenu = true;
  }

  @HostListener('mouseout')
  public onHoverEnd() {
    this.openMenu = false;
  }
}
